import { ThemeEvents } from '@theme/events';

const WATCHDOG_ATTR = 'data-kbite-watchdog';

/**
 * @param {string | number | null | undefined} variantId
 * @returns {boolean}
 */
export function isKbiteWatchdogVariant(variantId) {
  if (variantId == null || variantId === '') return false;
  const themeFn = globalThis.Theme?.isKbiteWatchdogVariant;
  if (typeof themeFn === 'function') {
    return themeFn(variantId);
  }
  const ids = globalThis.Theme?.kbiteWatchdogVariantIds;
  return Array.isArray(ids) && ids.includes(String(variantId));
}

/**
 * @param {boolean} enabled
 * @param {ParentNode} [root]
 */
function setWatchdogMode(enabled, root = document) {
  const value = enabled ? 'true' : 'false';
  const targets = [
    document.documentElement,
    document.body,
    ...root.querySelectorAll('.shopify-section, product-form-component, sticky-add-to-cart'),
  ];

  for (const el of targets) {
    if (!(el instanceof HTMLElement)) continue;
    el.setAttribute(WATCHDOG_ATTR, value);
  }

  const sticky = root.querySelector('sticky-add-to-cart');
  if (sticky instanceof HTMLElement) {
    sticky.dataset.preparingVariant = value;
    if (enabled) {
      sticky.dataset.variantAvailable = 'false';
    }
  }

  const productForm = root.querySelector('product-form-component');
  if (productForm instanceof HTMLElement) {
    productForm.dataset.preparingVariant = value;
  }
}

/**
 * @param {CustomEvent} event
 */
function onVariantUpdate(event) {
  const detail = event.detail;
  const productId = detail?.data?.productId ?? detail?.data?.newProduct?.id;
  const script = document.querySelector(`script[src*="kbite-visibility"][data-product-id]`);
  const boundProductId = script instanceof HTMLElement ? script.dataset.productId : null;

  if (boundProductId && productId && String(productId) !== String(boundProductId) && !detail?.data?.newProduct) {
    return;
  }

  const root = (event.target instanceof Element ? event.target.closest('.shopify-section') : null) || document;
  const variantPicker =
    root instanceof Element
      ? root.querySelector('variant-picker')
      : document.querySelector('variant-picker');
  const isFullySelected = variantPicker && 'isFullySelected' in variantPicker ? variantPicker.isFullySelected : true;
  const variantId = isFullySelected ? detail?.resource?.id : null;
  setWatchdogMode(isKbiteWatchdogVariant(variantId), root);
}

function initFromScript() {
  const script = document.querySelector('script[src*="kbite-visibility"][data-product-id]');
  if (!(script instanceof HTMLElement)) return;

  const productId = script.dataset.productId;
  const initial = script.dataset.initialWatchdog === 'true';
  const root =
    (productId &&
      document.querySelector(`.shopify-section:has(product-form-component[data-product-id="${productId}"])`)) ||
    document.querySelector('.shopify-section:has(product-form-component)') ||
    document;

  const urlVariant = new URLSearchParams(window.location.search).get('variant');
  if (urlVariant) {
    setWatchdogMode(isKbiteWatchdogVariant(urlVariant), root);
    return;
  }

  setWatchdogMode(initial, root);
}

initFromScript();
document.addEventListener(ThemeEvents.variantUpdate, onVariantUpdate);
